import ScalarIconBook_vue_vue_type_script_setup_true_lang_default from "./ScalarIconBook.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconBook.vue
var ScalarIconBook_default = ScalarIconBook_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconBook_default as default };

//# sourceMappingURL=ScalarIconBook.js.map